import { Component, Inject, Output, EventEmitter, Optional, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

export interface DeleteConfirmationData {
    item: any;
    description?: string;
    fullDescription?: string;
    includeThis: boolean;
}

@Component({
    selector: 'app-delete-confirmation',
    styleUrls: ['./delete-confirmation.component.scss'],
    templateUrl: './delete-confirmation.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule
    ]
})
export class DeleteConfirmationComponent {
    // For AppDialogWrapperService pattern
    @Output() confirmClicked = new EventEmitter<DeleteConfirmationData>();
    @Output() cancelDialog = new EventEmitter<void>();

    @Input() data: DeleteConfirmationData;
    
    // Getters for template - computed on-demand to avoid change detection issues
    get displayDescription(): string {
        if (!this.data) {
            return 'record';
        }
        return this.data.description != null ? this.data.description : "record";
    }

    get displayTitleDescription(): string {
        if (!this.data) {
            return 'Record';
        }
        return this.data.description != null ? this.data.description : "Record";
    }

    get displayMessage(): string {
        if (!this.data) {
            return '';
        }
        return this.data.includeThis ? "this " : "";
    }

    constructor(
        @Optional() public dialogRef: MatDialogRef<DeleteConfirmationComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) injectedData?: DeleteConfirmationData
    ) {
        // Support both @Input and @Inject patterns
        if (injectedData) {
            this.data = injectedData;
        }
        if (!this.data) {
            this.data = this.getDefaultData();
        }
    }

    private getDefaultData(): DeleteConfirmationData {
        return {
            item: null,
            description: undefined,
            fullDescription: undefined,
            includeThis: false
        };
    }

    onConfirmClick(): void {
        if (this.dialogRef) {
            // Direct MatDialog usage
            this.dialogRef.close(this.data);
        } else {
            // AppDialogWrapperService usage
            this.confirmClicked.emit(this.data);
        }
    }

    onCancelClick(): void {
        if (this.dialogRef) {
            // Direct MatDialog usage
            this.dialogRef.close();
        } else {
            // AppDialogWrapperService usage
            this.cancelDialog.emit();
        }
    }
}
